import { Menu, Text } from "@mantine/core";
import { useLocation } from "react-router";

import text from "../../Text.module.css";
import { getTextProps } from "../../utils";
import { HeaderNavMenuItem } from "../MenuItem";

import type { MantineSize } from "@mantine/core";
import type { FC } from "react";
import type { NavLinkItem } from "../../types";

export type HeaderNavSubmenuProps = NavLinkItem &
  Required<Pick<NavLinkItem, "children">> & {
    size?: MantineSize;
  };

export const HeaderNavSubmenu: FC<HeaderNavSubmenuProps> = ({ children, label, size, to }) => {
  const { pathname } = useLocation();
  const textProps = getTextProps(pathname, to);

  return (
    <Menu.Sub offset={6}>
      <Menu.Sub.Target>
        {/* It does not work here :( */}
        {/* <HeaderNavMenuItem label={label} size={size} sub to={to} /> */}
        <Menu.Sub.Item px="lg" py="sm">
          <Text classNames={text} size={size} {...textProps}>
            {label}
          </Text>
        </Menu.Sub.Item>
      </Menu.Sub.Target>
      <Menu.Sub.Dropdown py="md">
        {children.map((item, index) => (
          <HeaderNavMenuItem key={index} label={item.label} size={size} to={item.to} link />
        ))}
      </Menu.Sub.Dropdown>
    </Menu.Sub>
  );
};
